export default "__VITE_ASSET__DZjzv2wY__"